import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import { FlagsPermissionBookingV3 } from "@/feature-flags/flag-booking-v3";
import { FlagsPermissionBookingV4 } from "@/feature-flags/flag-booking-v4";
const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");
const ShipmentBooking = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/shipment/booking-v2/index.vue"
  );
const TabBooking = () =>
  import(
    /* webpackChunkName: "STTBookingList" */ "@/app/ui/views/shipment/booking-v2/tab-booking/tab-list-booking.vue"
  );
const TabBookingClientCBP = () =>
  import(
    /* webpackChunkName: "STTBookingClientCBP" */ "@/app/ui/views/shipment/booking-v2/tab-booking/tab-list-booking-client-cbp.vue"
  );
const CreateBookingV3 = () =>
  import(
    /* webpackChunkName: "CreateBookingV3" */ `@/app/ui/views/shipment/booking/create-booking-v3/create-booking-manual.vue`
  );
const CreateBookingV4 = () =>
  import(
    /* webpackChunkName: "CreateBookingV4" */ `@/app/ui/views/shipment/booking/create-booking-v4/create-booking-manual.vue`
  );
const CreateBookingClientV3 = () =>
  import(
    /* webpackChunkName: "CreateBookingV3" */ `@/app/ui/views/shipment/booking/create-booking-v3/create-booking-client.vue`
  );
const CreateBookingClientV4 = () =>
  import(
    /* webpackChunkName: "CreateBookingClientV4" */ `@/app/ui/views/shipment/booking/create-booking-v4/create-booking-client.vue`
  );
const EditBookingV3 = () =>
  import(
    /* webpackChunkName: "InstantBooking" */ "@/app/ui/views/shipment/booking/create-booking-v3/edit-booking.vue"
  );
export const EditBookingV4 = () =>
  import(
    /* webpackChunkName: "EditBookingV4" */ "@/app/ui/views/shipment/booking/create-booking-v4/edit-booking.vue"
  );

const DuplicateSttRetail = () =>
  import(
    /* webpackChunkName: "CreateBookingV3" */ "@/app/ui/views/shipment/booking-v2/duplicate-stt/retail/index.vue"
  );

const DuplicateSttClient = () =>
  import(
    /* webpackChunkName: "CreateBookingV3" */ "@/app/ui/views/shipment/booking-v2/duplicate-stt/client/index.vue"
  );

const DuplicateSttRetailV4 = () =>
  import(
    /* webpackChunkName: "CreateBookingV4" */ "@/app/ui/views/shipment/booking/create-booking-v4/duplicate-stt/retail/index.vue"
  );

const DuplicateSttClientV4 = () =>
  import(
    /* webpackChunkName: "CreateBookingV4" */ "@/app/ui/views/shipment/booking/create-booking-v4/duplicate-stt/client/index.vue"
  );

const DetailBooking = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/shipment/booking/detail-booking/detail.vue"
  );

const CreateBooking = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/shipment/booking/config-create-booking/index.vue"
  );

const InstantBookingShipmentV2 = () =>
  import(
    /* webpackChunkName: "InstantBooking" */ "@/app/ui/views/shipment/booking/instant-booking-v2/index.vue"
  );

const CreateBookingShipment = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/shipment/booking/create-booking-v3/create-booking-shipment.vue"
  );
const EditBooking = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/shipment/booking/config-edit-booking/index.vue"
  );

const maskedPath = new Date().getTime() + Math.random() + "";
export default [
  {
    path: "/booking-v2",
    name: "booking-v2",
    component: Layout,
    meta: {
      icon: "booking",
      children: false,
      header: true,
      title: "Booking",
      name: "Booking",
      maskedPath: maskedPath,
      gtmEventName: "shipment_menu_clicked",
      gtmEventCustoms: {},
      gtmEventOption: ["userType", "timestamp", "userId"],
      permission: FlagsPermissionBooking.permission_booking_enable_v2
    },
    children: [
      {
        path: "",
        name: "booking-v2",
        component: ShipmentBooking,
        redirect: "/booking-v2/booking-list",
        meta: {
          header: true,
          icon: "booking",
          title: "Booking",
          name: "Booking",
          maskedPath: maskedPath,
          gtmEventName: "booking_submenu_clicked",
          gtmEventCustoms: {},
          gtmEventOption: ["userType", "timestamp", "userId"],
          permission: FlagsPermissionBooking.permission_booking_view_list_v2
        },
        children: [
          {
            path: "booking-list",
            name: "booking-v2-list",
            component: TabBooking,
            meta: {
              tab: "booking-v2-list",
              maskedPath: maskedPath,
              permission: FlagsPermissionBooking.permission_booking_view_list_v2
            }
          },
          {
            path: "booking-client-cbp-list",
            name: "booking-v2-client-cbp-list",
            component: TabBookingClientCBP,
            meta: {
              tab: "booking-v2-client-cbp-list",
              maskedPath: maskedPath
            }
          }
        ]
      }
    ]
  },
  {
    path: "/booking-v2",
    component: Layout,
    name: "create-booking-v2-stt",
    meta: {
      icon: "create-booking",
      hidden: true,
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_booking_create_manual
    },
    children: [
      {
        path: "create",
        name: "create-booking-v2-stt",
        component: CreateBooking,
        meta: {
          header: true,
          name: "bookingV3.create.title",
          title: "bookingV3.create.pageTitle",
          before: "/booking-v2",
          formType: "manual",
          maskedPath,
          validateAccount: true
        }
      }
    ]
  },
  {
    path: "/booking-v2",
    component: Layout,
    name: "create-booking-v2-stt-client",
    meta: {
      icon: "create-booking",
      hidden: true,
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_booking_create_for_corporate
    },
    children: [
      {
        path: "create-client",
        name: "create-booking-v2-stt-client",
        component: CreateBooking,
        meta: {
          header: true,
          name: "bookingV3.create.title",
          title: "bookingV3.create.pageTitle",
          before: "/booking-v2",
          formType: "client",
          maskedPath,
          validateAccount: true
        }
      }
    ]
  },
  {
    path: "/booking-v2",
    name: "booking-v3-create-retail",
    component: Layout,
    meta: {
      hidden: true,
      icon: "booking",
      permission: FlagsPermissionBookingV3.permission_booking_v3_create_manual,
      maskedPath: maskedPath,
      parent: "Booking"
    },
    children: [
      {
        path: "create-v3",
        name: "shipment-booking-v2-create",
        component: CreateBookingV3,
        meta: {
          header: true,
          name: "bookingV3.create.title",
          title: "bookingV3.create.title",
          before: "/booking-v2",
          maskedPath
        }
      }
    ]
  },
  {
    path: "/booking-v2",
    name: "booking-v4-create-retail",
    component: Layout,
    meta: {
      hidden: true,
      icon: "booking",
      permission: FlagsPermissionBookingV4.permission_booking_v4_create_manual,
      maskedPath: maskedPath,
      parent: "Booking",
      noPaddingWithBreadcrumbV2: true,
      newLayout: true,
    },
    children: [
      {
        path: "create-v4",
        name: "shipment-booking-v4-create",
        component: CreateBookingV4,
        meta: {
          header: true,
          name: "Booking Baru",
          title: "Booking Baru",
          before: "/booking-v2",
          maskedPath,
          noPaddingWithBreadcrumbV2: true,
          newLayout: true,
        }
      }
    ]
  },
  {
    path: "/booking-v2",
    name: "booking-v4-create-client",
    component: Layout,
    meta: {
      hidden: true,
      icon: "booking",
      permission: FlagsPermissionBookingV4.permission_booking_v4_create_client,
      maskedPath: maskedPath,
      parent: "Booking",
      noPaddingWithBreadcrumbV2: true,
      newLayout: true
    },
    children: [
      {
        path: "create-client-v4",
        name: "shipment-booking-v4-create-client",
        component: CreateBookingClientV4,
        meta: {
          header: true,
          name: "bookingV4Client.breadcrumb.title",
          title: "Booking Klien",
          before: "/booking-v2",
          maskedPath,
          noPaddingWithBreadcrumbV2: true,
          newLayout: true
        }
      }
    ]
  },
  {
    path: "/booking-v2",
    name: "booking-v2-create-client",
    component: Layout,
    meta: {
      hidden: true,
      icon: "booking",
      permission: FlagsPermissionBookingV3.permission_booking_v3_create_client,
      maskedPath: maskedPath,
      parent: "Booking"
    },
    children: [
      {
        path: "create-client-v3",
        name: "shipment-booking-v3-create-client",
        component: CreateBookingClientV3,
        meta: {
          header: true,
          name: "bookingV3.create.title",
          title: "bookingV3.create.pageTitle",
          maskedPath,
          before: "/booking-v2"
        }
      }
    ]
  },
  {
    path: "/booking-v2",
    component: Layout,
    name: "create-booking-v2-stt-by-shipment-id",
    meta: {
      icon: "create-booking",
      hidden: true,
      parent: "Booking",
      maskedPath,
      permission:
        FlagsPermissionBookingV3.permission_booking_v3_create_markeplace
    },
    children: [
      {
        path: "create/by-shipment-id",
        name: "create-booking-v2-stt-by-shipment-id",
        component: CreateBookingShipment,
        meta: {
          header: true,
          name: "bookingV3.bookingApps.title",
          title: "bookingV3.bookingApps.pageTitle",
          before: "/booking-v2",
          backPath: "/booking-v2",
          maskedPath,
          validateAccount: true,
          newLayout: true
        }
      }
    ]
  },
  {
    path: "/booking-v2",
    component: Layout,
    name: "create-instant-booking-v2-shipment",
    meta: {
      icon: "create-booking",
      hidden: true,
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_instant_booking_create
    },
    children: [
      {
        path: "create/instant-booking-shipment",
        name: "create-instant-booking-v2-shipment",
        component: InstantBookingShipmentV2,
        meta: {
          header: true,
          name: "bookingV3.instantBooking.title",
          title: "bookingV3.instantBooking.pageTitle",
          before: "/booking-v2",
          maskedPath,
          validateAccount: true
        }
      }
    ]
  },
  {
    path: "/booking-v2",
    component: Layout,
    name: "booking-v2-edit-retail",
    meta: {
      hidden: true,
      icon: "booking",
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_booking_enable_v2
    },
    children: [
      {
        path: ":id/edit-v3",
        name: "shipment-booking-v2-edit",
        component: EditBookingV3,
        meta: {
          header: true,
          name: "bookingV3.edit.title",
          title: "bookingV3.edit.pageTitle",
          before: "/booking-v2/:id",
          maskedPath,
          isAuth: true,
          bookingPath: "/booking-v2",
        }
      }
    ]
  },
  {
    path: "/booking-v2",
    component: Layout,
    name: "booking-v2-duplicate",
    meta: {
      hidden: true,
      icon: "booking",
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_booking_enable_v2
    },
    children: [
      {
        path: ":id/create",
        name: "shipment-booking-v2-duplicate-retail",
        component: DuplicateSttRetail,
        meta: {
          header: true,
          name: "bookingV3.create.title",
          title: "bookingV3.create.pageTitle",
          maskedPath,
          isAuth: true,
          bookingPath: "/booking-v2",
        }
      },
      {
        path: ":id/create-client",
        name: "shipment-booking-v2-duplicate-client",
        component: DuplicateSttClient,
        meta: {
          header: true,
          name: "bookingV3.create.title",
          title: "bookingV3.create.pageTitle",
          maskedPath,
          isAuth: true,
          bookingPath: "/booking-v2",
        }
      }
    ]
  },
  {
    path: "/booking-v2",
    component: Layout,
    name: "booking-v2-duplicatev-4",
    meta: {
      hidden: true,
      icon: "booking",
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_booking_enable_v2,
      noPaddingWithBreadcrumbV2: true,
      newLayout: true
    },
    children: [
      {
        path: ":id/create-v4",
        name: "shipment-booking-v2-duplicate-retail-v4",
        component: DuplicateSttRetailV4,
        meta: {
          header: true,
          title: "Booking Baru",
          name: "Booking Baru",
          maskedPath,
          isAuth: true,
          bookingPath: "/booking-v2",
          noPaddingWithBreadcrumbV2: true,
          newLayout: true
        }
      },
      {
        path: ":id/create-client-v4",
        name: "shipment-booking-v2-duplicate-client-v4",
        component: DuplicateSttClientV4,
        meta: {
          header: true,
          title: "Booking Baru",
          name: "Booking Baru",
          maskedPath,
          isAuth: true,
          bookingPath: "/booking-v2",
          noPaddingWithBreadcrumbV2: true,
          newLayout: true
        }
      }
    ]
  },
  {
    path: "/booking-v2",
    component: Layout,
    name: "booking-v2-detail",
    meta: {
      title: "Booking | Detail",
      hidden: true,
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_booking_view_detail
    },
    children: [
      {
        path: ":id",
        name: "shipment-booking-v2-detail",
        component: DetailBooking,
        meta: {
          header: true,
          isAuth: true,
          maskedPath,
          bookingPath: "/booking-v2"
        }
      }
    ]
  },
  {
    path: "/booking-v2",
    component: Layout,
    name: "booking-v2-edit",
    meta: {
      title: "Booking | Edit",
      hidden: true,
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_booking_edit
    },
    children: [
      {
        path: ":id/edit",
        name: "edit-booking-v2",
        component: EditBooking,
        meta: {
          header: true,
          name: "bookingV3.edit.title",
          title: "bookingV3.edit.pageTitle",
          before: "/booking-v2/:id",
          bookingPath: "/booking-v2",
          maskedPath,
          isAuth: true
        }
      }
    ]
  },
  {
    path: "/booking-v2",
    component: Layout,
    name: "booking-v2-edit-v4",
    meta: {
      hidden: true,
      icon: "booking",
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_booking_enable_v2,
      noPaddingWithBreadcrumbV2: true,
      newLayout: true
    },
    children: [
      {
        path: ":id/edit-v4",
        name: "shipment-booking-v2-v4-edit",
        component: EditBookingV4,
        meta: {
          header: true,
          title: "bookingV3.edit.pageTitle",
          name: "bookingV3.edit.title",
          before: "/booking-v2/:id",
          maskedPath,
          isAuth: true,
          bookingPath: "/booking-v2",
          noPaddingWithBreadcrumbV2: true,
          newLayout: true
        }
      }
    ]
  }
];
